import React from "react";
import { useBatchMode } from "../contexts/BatchModeContext";

export default function BatchModeToggle({ className = "" }) {
  const { mode, setMode } = useBatchMode();
  return (
    <div className={`inline-flex border border-white/20 ${className}`} data-testid="batch-mode-toggle">
      {[
        { key: "small", label: "Small Batch" },
        { key: "wholesale", label: "Wholesale" },
      ].map((opt) => (
        <button
          key={opt.key}
          data-testid={`batch-mode-${opt.key}`}
          onClick={() => setMode(opt.key)}
          className={`px-4 md:px-5 py-2 font-display text-xs uppercase tracking-[0.2em] transition-colors ${
            mode === opt.key
              ? "bg-[var(--hk-orange)] text-black"
              : "text-white/70 hover:text-white"
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
